﻿// Uploadery hardening + fallback FS Solutions

let uploaderyBootAttempts = 0;
let uploaderyObserverStarted = false;
let nativeUploaderyEventsBound = false;
const MAX_BOOT_TRIES = 150;          // ~12 s
const FALLBACK_CLASS = "uploadery-fallback";

function showUploaderyFallback(message, details = {}) {
  const container = document.querySelector("#uploadery-container");
  if (!container) return;

  const form = container.querySelector("form[data-uploadery]") || container.querySelector("form");
  const label = form?.querySelector("label") || container.querySelector("label");
  if (!label) return;

  const input =
    label.querySelector("input[type=\"file\"]") ||
    container.querySelector("input[type=\"file\"]");
  const fileBlock = label.querySelector(".spb-fileupload") || (input ? input.closest("div") : null);

  label.classList.add(FALLBACK_CLASS);

  let title = label.querySelector(".eyewear-uploadery-title") || label.querySelector(".uploadery-title");
  if (!title && fileBlock) {
    title = document.createElement("div");
    title.className = "uploadery-title";
    label.insertBefore(title, fileBlock);
  }
  if (title) title.textContent = "Upload indisponible";

  let msg = label.querySelector(".uploadery-fallback-message");
  if (!msg) {
    msg = document.createElement("div");
    msg.className = "uploadery-fallback-message";
    label.appendChild(msg);
  }
  msg.innerHTML = `<div>${message}</div><small>Merci de prevenir un administrateur.</small>`;

  if (fileBlock) fileBlock.style.display = "none";

  console.warn("[uploadery] fallback", { message, details });
}
(function bootUploadery() {
  observeUploaderyContainer();
  setupNativeUploaderyEvents();
  applyCustomText();

  const hasShoppad = typeof Shoppad !== "undefined" && Shoppad.$;
  const hasContainer = document.querySelector("#uploadery-container");
  if (!hasShoppad) {
    uploaderyBootAttempts++;
    if (uploaderyBootAttempts > MAX_BOOT_TRIES) {
      if (hasContainer) showUploaderyFallback("Le module ne s'est pas initialise.");
      return;
    }
    return setTimeout(bootUploadery, 80);
  }
  initUploadery();
})();

function initUploadery() {
  window.Shoppad = window.Shoppad || {};
  window.Shoppad.apps = window.Shoppad.apps || {};
  window.Shoppad.apps.uploadery = window.Shoppad.apps.uploadery || {};
  window.Shoppad.apps.uploadery.strings = {
    unacceptedFileType: "Desole, ce format de fichier n'est pas autorise",
    exceedsFileSize: "Desole, ce fichier est trop volumineux",
    exceedsImageMaxWidth: "Desole, la largeur de cette image est trop grande",
    exceedsImageMaxHeight: "Desole, la hauteur de cette image est trop grande",
    exceedsImageMinWidth: "Desole, la largeur de cette image est trop petite",
    exceedsImageMinHeight: "Desole, la hauteur de cette image est trop petite",
    incorrectAspectRatio:
      "Desole, cette image n'est pas dans le bon ratio. Elle doit etre : {{aspect_ratio}}",
    requiredFieldMessage:
      "Veuillez telecharger votre/vos fichier(s) avant d'ajouter au panier.",
  };

  Shoppad.$(document).ready(function () {
    observeUploaderyContainer();
    setupUploaderyEvents();
  });
}

function observeUploaderyContainer() {
  if (uploaderyObserverStarted) return;
  uploaderyObserverStarted = true;
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.type === "childList") {
        m.addedNodes.forEach((n) => {
          if (
            n.nodeType === 1 &&
            (n.id === "uploadery-container" ||
              (n.querySelector && n.querySelector("#uploadery-container")))
          ) {
            applyCustomText();
          }
        });
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(applyCustomText, 100);
}

function applyCustomText() {
  const container = document.querySelector("#uploadery-container");
  if (!container) return;

  const form = container.querySelector("form[data-uploadery]") || container.querySelector("form");
  const label = form?.querySelector("label") || container.querySelector("label");
  if (!label) return;

  const input =
    label.querySelector("input[type=\"file\"]") ||
    container.querySelector("input[type=\"file\"]");
  const fileBlock = label.querySelector(".spb-fileupload") || (input ? input.closest("div") : null);
  if (!fileBlock) return;

  // Si eyewear-flow a deja mis un titre, garder le texte synchronise
  const eyewearTitle = label.querySelector(".eyewear-uploadery-title");
  if (eyewearTitle) {
    eyewearTitle.textContent = "Partager votre ordonnance";
  }

  // Assurer un texte visible dans le bouton sans retirer l'input
  let text = fileBlock.querySelector(".uploadery-button-text");
  if (!text) {
    text = document.createElement("span");
    text.className = "uploadery-button-text";
    fileBlock.appendChild(text);
  }
  text.textContent = "Partager votre ordonnance";
  fileBlock.classList.add("custom-text-applied");
}

function setupNativeUploaderyEvents() {
  if (nativeUploaderyEventsBound) return;
  nativeUploaderyEventsBound = true;

  const clearOverlay = () => {
    document.querySelectorAll("#uploadery-container .sp-validate-overlay").forEach((el) => el.remove());
  };

  const setStatus = (text, el) => {
    if (!el) return;
    let status = el.querySelector(".uploadery-status");
    if (!status) {
      status = document.createElement("span");
      status.className = "uploadery-status";
      el.appendChild(status);
    }
    status.textContent = text;
  };

  document.addEventListener(
    "click",
    (event) => {
      const target = event.target;
      if (target instanceof HTMLElement && target.closest("#uploadery-container label")) clearOverlay();
    },
    true
  );

  document.addEventListener(
    "change",
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== "file" || !input.closest("#uploadery-container")) return;
      if (input.files && input.files.length > 0) {
        const fileName = input.files[0].name;
        const label = input.closest("form")?.querySelector("label") || input.closest("label");
        setStatus("Televersement en cours... (" + fileName + ")", label);
        window.setTimeout(clearOverlay, 7000);
      }
    },
    true
  );

  document.addEventListener(
    "uploadProgress",
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLElement) || !form.matches("form[data-uploadery]")) return;
      const progress = event.detail?.progress;
      const bar = form.querySelector(".uploaderyProgressBar span");
      if (bar && progress != null) bar.style.width = progress + "%";
    },
    true
  );

  document.addEventListener(
    "uploadSuccess",
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLElement) || !form.matches("form[data-uploadery]")) return;
      clearOverlay();
      const file = String(event.detail?.file || "");
      const fileName = file.match(/[^\\/]+$/)?.[0] || "ordonnance";
      const clean = fileName.includes("-") ? fileName.substring(fileName.indexOf("-") + 1) : fileName;
      const label = form.querySelector("label");
      setStatus("Fichier envoye : " + clean, label);
      const bar = form.querySelector(".uploaderyProgressBar span");
      if (bar) bar.style.width = "100%";
    },
    true
  );

  document.addEventListener(
    "uploadError",
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLElement) || !form.matches("form[data-uploadery]")) return;
      clearOverlay();
      const label = form.querySelector("label");
      setStatus("Erreur lors du televersement. Merci de reessayer.", label);
    },
    true
  );
}

function setupUploaderyEvents() {
  const $ = Shoppad.$;
  const clearOverlay = () => $(".sp-validate-overlay").remove();
  clearOverlay();
  $(document).on("click", "#uploadery-container label", () => clearOverlay());
  let watchdogTimer = null;
  const startWatchdog = () => {
    clearTimeout(watchdogTimer);
    watchdogTimer = setTimeout(() => {
      const stuck = document.querySelector(
        "#uploadery-container .sp-validate-overlay"
      );
      if (stuck) {
        stuck.remove();
        console.warn("[uploadery] overlay persistant supprime");
        const label =
          document.querySelector("#uploadery-container form[data-uploadery] label") ||
          document.querySelector("#uploadery-container label");
        setStatus("Televersement bloque. Reessayez.", label);
      }}, 7000);
  };

  const setStatus = (text, el) => {
    if (!el) return;
    let status = el.querySelector(".uploadery-status");
    if (!status) {
      status = document.createElement("span");
      status.className = "uploadery-status";
      el.appendChild(status);
    }
    status.textContent = text;
  };

  $(document).on("change", "#uploadery-container input[type='file']", function () {
    if (this.files && this.files.length > 0) {
      const fileName = this.files[0].name;
      const label = this.closest("form")?.querySelector("label");
      setStatus("Televersement en cours... (" + fileName + ")", label);
      console.info("[uploadery] fichier sélectionné", fileName);
      startWatchdog();
    }
  });

  $(document).on("uploadProgress", "form[data-uploadery]", function (e) {
    const p = e.originalEvent.detail.progress;
    const bar = this.querySelector(".uploaderyProgressBar span");
    if (bar) bar.style.width = p + "%";
    console.info("[uploadery] progress", p);
  });

  $(document).on("uploadSuccess", "form[data-uploadery]", function (e) {
    clearTimeout(watchdogTimer);
    clearOverlay();
    const fileName = e.originalEvent.detail.file.match(/[^\\\\/]+$/)[0];
    const clean = fileName.substring(fileName.indexOf("-") + 1);
    const label = this.querySelector("label");
    setStatus("Fichier envoye : " + clean, label);
    const bar = this.querySelector(".uploaderyProgressBar span");
    if (bar) bar.style.width = "100%";
  });

  $(document).on("uploadError", "form[data-uploadery]", function (e) {
    clearTimeout(watchdogTimer);
    clearOverlay();
    console.error("[uploadery] erreur", e.originalEvent?.detail);
    const label = this.querySelector("label");
    setStatus("Erreur lors du televersement. Merci de reessayer.", label);
    console.warn("[uploadery] uploadError");
  });
}







